import {Injectable} from "@angular/core";
import {HttpParams} from "@angular/common/http";
import {PDFInfo, TemplateDetails, TemplateList} from "../models/template";
import {HttpService} from "./http.service";
import {Observable} from "rxjs";
import {UtilService} from "./util.service";

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  constructor(private httpService: HttpService,
              private util: UtilService) {
  }

  getTemplates(): Observable<TemplateList> {
    const options = { headers: this.httpService.jsonHeaders };
    const url = '/edit-templates-view';

    return this.httpService.Post<TemplateList>(url, options)
  }

  generateTemplateBasedOnDocumentType(docId: number, aNum?: string): Observable<TemplateDetails> {
    let httpParams: HttpParams = new HttpParams();
    httpParams = httpParams.append('docId', docId)

    if (aNum) {
      httpParams = httpParams.append('aNum', aNum)
    }

    const options = { headers: this.httpService.formHeaders };
    const url = '/templates';

    return this.httpService.Post<TemplateDetails>(url, httpParams, options);
  }

  createPdf(content: string, docId: number): Observable<PDFInfo> {
    const formData = {
      content: this.replaceChars(content),
      docId: docId
    }

    const httpParams =  this.httpService.createHttpParams(formData);
    const options = { headers: this.httpService.formHeaders };
    const url = '/create-pdf';

    return this.httpService.Post<PDFInfo>(url, httpParams, options);
  }

  downloadTempPdf(fileName: string, docId: number) {
    window.open(this.util.getBaseURL() + "/epds/download-temp-pdf/" + docId, '_blank');
  }

  download(data: Blob, filename: string) {
    const link = document.createElement('a');
    const fileURL = URL.createObjectURL(data);

    link.style.visibility = 'hidden';
    link.href = fileURL;
    link.download = filename;

    document.body.append(link);
    link.click();
    URL.revokeObjectURL(fileURL);
    link.remove();
  }

  saveTemplate(content: string, typeOfDoc: number){
    const formData = {
      content : this.replaceChars(content),
      docId : typeOfDoc
    }

    const httpParams =  this.httpService.createHttpParams(formData);
    const options = { headers: this.httpService.formHeaders };
    const url = '/save-edited-template';

    return this.httpService.Post<any>(url, httpParams, options);
  }

  replaceChars(content: string) : string {
    // Non-breaking hyphens don't appear correctly in the PDF, replacing with hyphens. Same with curly quotes.
    return content && content.replace(/\u2011/g, '-').replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201c\u201d]/g, '"').replace(/§/g, '&sect;');
  }


}
